module.exports = __webpack_public_path__ + "static/media/ScreenShot_DownloadDropdn_2020-06-24.c6c5d2d3.png";